import React from 'react';
import type { CommandInternal, FooterProps } from '../../../../common/types/commands/index.tsx';
import { components } from '../../../../common/ui/components/index.tsx';

export const Footer = (
	props: FooterProps & { activeCommand: CommandInternal | undefined },
): React.JSX.Element => {
	const { activeCommand, ...rest } = props;
	const FooterComponent = activeCommand?.components?.Footer || components.Footer;

	return <FooterComponent {...rest} />;
};
